import(/* webpackMode: "eager" */ "/vercel/path0/my-project/src/app/faq/page.tsx");
